import { AsyncPageRender } from '@components/AsyncComponent';
import { ProtectedRoute } from '@components/Layout/ProtectedRoute';
import { pageModule } from '@components/pageModule';
import { Route } from '@packages/router';
import React from 'react';

export const routes$ = {
    HelpList: AsyncPageRender(() => pageModule(import('./Views/List/Apparel'))),
    HelpView: AsyncPageRender(() => pageModule(import('./Views/View/Apparel'))),
};

function Router() {
    return (
        <>
            <Route
                name={'Help.List'}
                exact
                path={'/help'}
                component={ProtectedRoute(routes$.HelpList, { noSidebar: true })}
            />
            <Route
                name={'Help.View'}
                exact
                path={'/help/:id'}
                component={ProtectedRoute(routes$.HelpView, { noSidebar: true })}
            />
        </>
    );
}

export default Router;
